import {
  COMPANIES_FILTER_CHANGE,
  COMPANIES_PAGE_CHANGE,
  INCIDENTS_FILTER_CHANGE,
  NEW_COMPANY_ADD_ASYNC,
  NEW_COMPANY_RESET_MESSAGE,
  PARTNER_COMPANIES_GET_ASYNC,
  PARTNER_INCIDENTS_GET_ASYNC,
  PARTNER_STATISTICS_GET_ASYNC,
  PARTNER_SUCCESS_SUBMISSION_SEND_ASYNC,
  SEARCH_CHANGE,
  SEARCH_RESET,
  SORT_PROPERTY_CHANGE,
} from './constants'

const fetchCompanies = () => ({ type: PARTNER_COMPANIES_GET_ASYNC.INITIATE })
const fetchCompaniesCancel = () => ({
  type: PARTNER_COMPANIES_GET_ASYNC.CANCEL,
})
export const fetchCompaniesSuccess = (data) => ({
  type: PARTNER_COMPANIES_GET_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchCompaniesError = (error) => ({
  type: PARTNER_COMPANIES_GET_ASYNC.ERROR,
  error,
})

const addCompany = (data) => ({
  type: NEW_COMPANY_ADD_ASYNC.INITIATE,
  payload: { data },
})
export const addCompanySuccess = (data) => ({
  type: NEW_COMPANY_ADD_ASYNC.SUCCESS,
  payload: { data },
})
export const addCompanyError = (error) => ({
  type: NEW_COMPANY_ADD_ASYNC.ERROR,
  error,
})

const addCompanyResetMessage = () => ({ type: NEW_COMPANY_RESET_MESSAGE })

const fetchPartnerIncidents = () => ({
  type: PARTNER_INCIDENTS_GET_ASYNC.INITIATE,
})
const fetchPartnerIncidentsCancel = () => ({
  type: PARTNER_INCIDENTS_GET_ASYNC.CANCEL,
})
export const fetchPartnerIncidentsSuccess = (data) => ({
  type: PARTNER_INCIDENTS_GET_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchPartnerIncidentsError = (error) => ({
  type: PARTNER_INCIDENTS_GET_ASYNC.ERROR,
  error,
})

const fetchPartnerStatistics = () => ({
  type: PARTNER_STATISTICS_GET_ASYNC.INITIATE,
})
const fetchPartnerStatisticsCancel = () => ({
  type: PARTNER_STATISTICS_GET_ASYNC.CANCEL,
})
export const fetchPartnerStatisticsSuccess = (data) => ({
  type: PARTNER_STATISTICS_GET_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchPartnerStatisticsError = (error) => ({
  type: PARTNER_STATISTICS_GET_ASYNC.ERROR,
  error,
})

const submitPartnerSuccessSubmission = (data) => ({
  type: PARTNER_SUCCESS_SUBMISSION_SEND_ASYNC.INITIATE,
  payload: { data },
})
export const submitPartnerSuccessSubmissionSuccess = (data) => ({
  type: PARTNER_SUCCESS_SUBMISSION_SEND_ASYNC.SUCCESS,
  payload: { data },
})
export const submitPartnerSuccessSubmissionError = (error) => ({
  type: PARTNER_SUCCESS_SUBMISSION_SEND_ASYNC.ERROR,
  error,
})
const resetPartnerSuccessSubmissionState = () => ({
  type: PARTNER_SUCCESS_SUBMISSION_SEND_ASYNC.CANCEL,
})

const changeIncidentsFilter = (filter) => ({
  type: INCIDENTS_FILTER_CHANGE,
  payload: { filter },
})

const companiesPageChange = (page) => ({
  type: COMPANIES_PAGE_CHANGE,
  payload: { page },
})
const companiesFilterChange = (filter) => ({
  type: COMPANIES_FILTER_CHANGE,
  payload: { filter },
})
const sortPropertyChange = (value) => ({
  type: SORT_PROPERTY_CHANGE,
  payload: { value },
})
const searchReset = () => ({ type: SEARCH_RESET })
export const searchChange = (q) => ({ type: SEARCH_CHANGE, payload: { q } })

export default {
  // to props
  fetchCompanies,
  fetchCompaniesCancel,
  addCompany,
  addCompanyResetMessage,
  changeIncidentsFilter,
  fetchPartnerIncidents,
  fetchPartnerIncidentsCancel,
  fetchPartnerStatistics,
  fetchPartnerStatisticsCancel,
  submitPartnerSuccessSubmission,
  resetPartnerSuccessSubmissionState,
  companiesPageChange,
  companiesFilterChange,
  searchChange,
  searchReset,
  sortPropertyChange,
}
